export enum SearchTimeslot {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  THIS_WEEK = 'this_week',
  NEXT_WEEK = 'next_week',
}

export interface TimeslotsResponse {
  [cpruId: number]: {
    [csId: number]: Date[];
  };
}
